class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.trapFocus = this.trapFocus.bind(this);

        // ✅ Close modal when clicking close buttons
        this.querySelectorAll('[data-close-modal]').forEach(button => {
            button.addEventListener('click', this.close);
        });

        // ✅ Prevents accidental closure when clicking inside the modal
        this.addEventListener('click', event => {
            if (event.target === this) this.close();
        });

        // ✅ Keyboard accessibility (Esc to close)
        document.addEventListener('keydown', this.handleKeydown);
    }

    open() {
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');

        // ✅ Trap focus inside modal
        this.focusableElements = this.querySelectorAll(
            'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        if (this.focusableElements.length) {
            this.focusableElements[0].focus();
        }
    }

    close() {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
    }

    handleKeydown(event) {
        if (event.key === 'Escape') {
            this.close();
        } else if (event.key === 'Tab') {
            this.trapFocus(event);
        }
    }

    trapFocus(event) {
        if (!this.hasAttribute('open')) return;

        const focusableElements = this.focusableElements;
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstFocusable) {
            event.preventDefault();
            lastFocusable.focus();
        } else if (!event.shiftKey && document.activeElement === lastFocusable) {
            event.preventDefault();
            firstFocusable.focus();
        }
    }
}

// ✅ Register the custom element safely (prevent double definitions)
if (!customElements.get('modal-dialog')) {
    customElements.define('modal-dialog', ModalDialog);
}
